import { Component, OnInit } from '@angular/core';
import { UserService } from '../shared/services/user.service';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { ModalDismissReasons, NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { NgxOtpInputConfig } from 'ngx-otp-input';
import { Subscription, timer } from 'rxjs';
import { UserAuthService } from '../shared/services/auth/user-auth.service';
declare function viewPassword(): any;
declare function viewCPassword(): any;

@Component({
  selector: 'ngbd-modal-content',
  template: `
		<div class="modal-header">
			<h4 style="color:black!important;" class="modal-title">Profile update</h4>
			<button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
		</div>
		<div class="modal-body">
			<h5 style="color:black!important;">Your email address has been successfully updated..</h5>
		</div>
		<div class="modal-footer">
			<button type="button" class="btn btn-blue submitBtn" (click)="activeModal.close('Close click')">OK</button>
		</div>
	`,
})
export class NgbdModalContent {
  constructor(public activeModal: NgbActiveModal) { }
}

@Component({
  selector: 'app-change-email',
  templateUrl: './change-email.component.html',
  styleUrls: ['./change-email.component.css'],
  animations: [
    trigger(
      'slideView',
      [
        state('true', style({ transform: 'translateX(100%)', opacity: 0 })),
        state('false', style({ transform: 'translateX(0)', opacity: 1 })),
        transition('0 => 1', animate('500ms', style({ transform: 'translateX(0)', 'opacity': 1 }))),
        transition('1 => 1', animate('500ms', style({ transform: 'translateX(100%)', 'opacity': 0 }))),
      ]),

    trigger('slideInOut', [
      transition(':enter', [
        style({ transform: 'translateX(100%)', opacity: 0 }),
        animate('200ms ease-in', style({ transform: 'translateX(0%)', 'opacity': 1 }))
      ]),

      transition(':leave', [
        style({ transform: 'translateX(0%)', opacity: 1 }),
        animate('0ms ease-in', style({ transform: 'translateX(100%)', 'opacity': 0 }))
      ])
    ])
  ]
})

export class ChangeEmailComponent implements OnInit {

  otpInputConfig: NgxOtpInputConfig = {
    otpLength: 4,
    autofocus: true,
    classList: {
      inputBox: "my-super-box-class",
      input: "my-super-class",
      inputFilled: "my-super-filled-class",
      inputDisabled: "my-super-disable-class",
      inputSuccess: "my-super-success-class",
      inputError: "my-super-error-class"
    }
  };
  //get from html forms

  password: string;
  newEmail: string;
  error: string;
  EmailChanged: boolean = false;
  changeEmailForm: FormGroup;
  submit: boolean = false;
  passwordNotMatchError: string;
  closeResult = '';
  emailOTP: boolean = false;
  phoneOTP: boolean = false;
  ConfirmationToken: string;
  OTPcounter: number = 0;
  //to Display otp input
  windowRef: any;
  showOTP: boolean = false; //this should false when init
  showResendOTP: boolean = false // to show resend otp button -- should be false when init

  //for otp timer
  countDown: Subscription;
  counter = 120;
  tick = 1000;
  success: any;
  changePhoneByPhoneCheck: boolean;
  response: any;
  localPhone: string;
  localEmail: string;
  sendOtpToEmail: any;
  user: any;
  apiCalled: boolean;
  oldEmail: any;
  phoneNumber: any;
  constructor(private userService: UserService, private _location: Location, private router: Router, private ngxloader: NgxUiLoaderService,
    private modalService: NgbModal, private userAuth: UserAuthService) {
    this.initChangePasswordForm();
    this.user = this.userAuth.getStoredUser();

    this.getSubscriptionDetails();
  }

  ngOnInit(): void {
  }

  changeEmail() {
    this.ngxloader.start();
    this.password = this.changeEmailForm.get("password").value;
    this.newEmail = this.changeEmailForm.get("new_email").value;
    var famData = {
      new_email: this.newEmail
    }
    if (localStorage.getItem('0') != null) {
      if (localStorage.getItem('0').includes('@')) {
        var email = this.localEmail;
        let mongoData = {
          email: this.newEmail
        }
        this.userService.changeEmailByEmail(email, mongoData).subscribe(resp => {
          if (resp.message === 'Email changed!') {
            this.userService.changeEmailMariaAPIByEmail(email, famData).subscribe(famResp => {
              if (famResp.message === 'Email changed successfully!') {
                this.ngxloader.stop();
                this.EmailChanged = true;
                //success pop up
                localStorage.setItem('0', this.newEmail);
                this.open();
                var linkData = { email: this.oldEmail, phone_number: this.phoneNumber }
                this.userService.sendEmailChangeNotification(linkData).subscribe(async (resp) => {
                  //user press ?
                });
              } else {
                this.error = famResp.message;
                this.ngxloader.stop();
              }

            });

          } else {
            this.error = resp.message;
            this.ngxloader.stop();
          }
        }, error => { this.error = 'Error changing email!' })
      }

      if (!localStorage.getItem('0').includes('@')) {
        var phone = localStorage.getItem('0')
        this.userService.changeEmailByPhone(this.newEmail, phone).subscribe(resp => {
          if (resp.message === 'Email changed!') {
            this.userService.changeEmailMariaAPIByPhone(phone, famData).subscribe(famResp => {
              if (famResp.message === 'Email changed successfully!') {
                this.ngxloader.stop();
                this.EmailChanged = true;
                //success pop up
                this.open();
                var linkData = { email: this.oldEmail, phone_number: this.localPhone }
                this.userService.sendEmailChangeNotification(linkData).subscribe(async (resp) => {
                  //user press ?
                });
              } else {
                this.error = famResp.message;
                this.ngxloader.stop();
              }

            });
          } else {
            this.error = resp.message;
            this.ngxloader.stop();
          }
        }, error => { this.error = 'Error changing email!' })

      }
    }
    else {
      this.error = 'Error changing email!'
    }
  }
  get f() {
    return this.changeEmailForm.controls;
  }

  initChangePasswordForm() {
    this.changeEmailForm = new FormGroup({
      new_email: new FormControl('', [Validators.required, Validators.pattern(/^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/), Validators.maxLength(254)]),
      password: new FormControl('', [Validators.required, Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&~`#^()_={}|:;"'<,>.])[A-Za-z\d@$!%*?&~`#^()_={}|:;"'<,>.]{8,}$/)]),
      OtpCode: new FormControl('', [Validators.required])
    }, { validators: this.passwordMatchingValidatior });
  }
  backClicked() {
    if (this.router.navigated) {
      this._location.back();
    }

  }

  clearPasswordNotMatchError() {
    this.passwordNotMatchError = null;
  }

  passwordMatchingValidatior: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const newEmail = control.get('new_email');
    const newPassword = control.get('password');

    if (newEmail.value != '' && newEmail.value != null) {
      var pattern = new RegExp(/^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/);
      let currentEmail = newEmail.value;
      var result = currentEmail.match(pattern);
    }

    if (newEmail.value != null && newEmail.value != '') {
      if (!result) {
        this.passwordNotMatchError = "Please enter a valid email address."
      } else {
        this.clearPasswordNotMatchError();
      }
    }
    if (newPassword.value != '' && newPassword.value != null) {
      var patternPass = new RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&~`#^()_={}|:;"'<,>.])[A-Za-z\d@$!%*?&~`#^()_={}|:;"'<,>.]{8,}$/);
      let newCurrentPassword = newPassword.value;
      var resultPass = newCurrentPassword.match(patternPass);
    }
    if (newPassword.value != '' && newPassword.value != null) {
      if (!resultPass) {
        this.passwordNotMatchError = "Password must be at least eight characters, with one uppercase letter, one lowercase letter, one number and one special character."
      } else {
        this.clearPasswordNotMatchError();
      }
    }
    return newEmail?.value ? null : { notmatched: true };
  };

  open() {
    const modalRef = this.modalService.open(NgbdModalContent).result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;

        if (localStorage.getItem('0').includes('@')) {
          localStorage.clear();
          this.router.navigate(['/login'])
        } else {
          this.backClicked();
        }
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;

        if (localStorage.getItem('0').includes('@')) {
          localStorage.clear();
          this.router.navigate(['/login'])
        } else {
          this.backClicked();
        }
      },
    );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  checkEmailOTP() {
    let email = this.changeEmailForm.get('new_email').value;
    let OTPinput = this.changeEmailForm.get('OtpCode').value;
    this.userService.checkEmailOTP(email, OTPinput).subscribe(resp => {
      /* if (res.OTP) {*/
      if (resp.message == 'OTP matches!') {

        this.changeEmail();
        this.clearInfoMessages();
        //delete temptable record
        //this.userService.deleteTempEmailRecord(email).subscribe(resp => { });

      }
      else {
        this.error = "Invalid Code!"
      }
    }
    )
  }
  resendOTP() {
    let email = this.changeEmailForm.get('new_email').value;
    this.ngxloader.start();
    if (email) {
      this.userService.getEmailOTP(email).subscribe(resp => {
        this.OTPcounter = resp.counter;
        if (this.OTPcounter < 3) {
          this.ngxloader.start();
          this.userService.sendEmail(email).subscribe(resp => {
            if (resp.message === 'Email was successfully sent!') {
              this.showOTP = true;
              this.startOTPTimer();
              this.ngxloader.stop();
              this.OTPcounter = this.OTPcounter + 1;
              var data = { otp: resp.otp, email: email, otp_sent_counter: this.OTPcounter, otp_sent_date: new Date() }
            } else {
              this.ngxloader.stop();
            }
          });
        }
        else {
          var dateHours;
          var DateNow = new Date();
          var dateSpan = new Date(resp.OTPSentDate);
          if (dateSpan.getHours() != 23) {
            dateHours = dateSpan.getHours() + 1
          }
          else {
            dateHours = 0;
          }
          dateSpan.setHours(dateHours);
          //var DateError = OTPDate - DateNow;
          if (DateNow >= dateSpan) {
            this.userService.sendEmail(email).subscribe(resp => {
              if (resp.message === 'Email was successfully sent!') {
                this.showOTP = true;
                this.startOTPTimer();
                this.OTPcounter = this.OTPcounter + 1;
                var data = { otp: resp.otp, email: email, otp_sent_counter: 0, otp_sent_date: new Date() }

                this.ngxloader.stop();
                this.clearInfoMessages();
              }
            });
            this.ngxloader.stop();
          }
          else {
            this.error = "You must wait an hour before resending again!";
            this.ngxloader.stop();
          }
        }
      });
    }
  }

  handeOtpChange(value: string[]): void {
    value.forEach(input => {
      if (input == '') {
        this.changeEmailForm.get('OtpCode').setValue(null);
      }
    });
  }

  handleFillEvent(value: string): void {
    this.changeEmailForm.get('OtpCode').setValue(value);

    //for auto-login 
    // setTimeout(() => {
    //   this.verifyLoginCode();  
    // });

  }

  resetOTPTimer() {
    this.showResendOTP = false;
    this.counter = 120
  }

  startOTPTimer() {
    this.resetOTPTimer();
    this.countDown = timer(0, this.tick).subscribe((count) => {
      if (count == 120) {
        //show resent otp button
        this.showResendOTP = true;
        if (this.countDown) {
          this.countDown.unsubscribe();
        }
      }
      --this.counter;
    });
  }

  clearInfoMessages() {
    this.error = null;
    this.success = null;
  }

  removePlusFromstring(phoneNumber) {
    return phoneNumber.split('+').join('')
  }

  verifyUserSubscription() {
    this.clearInfoMessages();
    if (!localStorage.getItem('0').includes('@')) {
      this.localPhone = localStorage.getItem('0')
    }
    else {
      this.localEmail = localStorage.getItem('0')
    }
    let email = this.changeEmailForm.get('new_email').value;
    this.sendOtpToEmail = email
    if (email) {
      let data = {
        email_id: email
      }
      this.userService.validateUserEmailAddress(data).subscribe(resp => {
        this.ngxloader.start();
        if (resp.message === 'success (email already exists)') {
          this.response = resp.message;
          this.error = "This email is already registered";
          this.ngxloader.stop();
        }
      }, err => {
        this.ngxloader.start();
        this.userService.getEmailOTP(email).subscribe(resp => {
          if (resp.OTP) {
            this.userService.sendEmail(email).subscribe(resp => {
              if (resp.message === 'Email was successfully sent!') {
                this.emailOTP = true;
                this.showOTP = true;
                this.startOTPTimer();
                var data = {
                  otp: resp.otp,
                  email: email,
                  otp_sent_counter: 0,
                  otp_sent_date: new Date()
                }
              }
              this.ngxloader.stop();
            });
          }
          else {
            this.userService.sendEmail(email).subscribe(resp => {
              if (resp.message === 'Email was successfully sent!') {
                this.showOTP = true;
                this.emailOTP = true;
                this.startOTPTimer();
                var data = {
                  otp: resp.otp,
                  email: email,
                  otp_sent_counter: this.OTPcounter,
                  otp_sent_date: new Date()
                }

              }
              this.ngxloader.stop();
            });
          }
        });
      });
    }
  }

  getSubscriptionDetails() {
    this.ngxloader.start();
    if (this.user.includes("@")) {
      this.userService.getSubscriptionDetailsWithEmail(this.user).subscribe(resp => {
        if (resp.message == 'success') {
          this.oldEmail = resp.email_id
          this.phoneNumber = resp.phone_number;
        }
        this.apiCalled = true;
        this.ngxloader.stop();
      }, error => {
        this.apiCalled = true;
        this.ngxloader.stop();
      })
    } else {
      this.userService.getSubscriptionDetailsWithPhoneNumber(this.user).subscribe(resp => {
        if (resp.message == 'success') {
          this.oldEmail = resp.email_id
        }
        this.apiCalled = true;
        this.ngxloader.stop();
      }, error => {
        this.apiCalled = true;
        this.ngxloader.stop();
      })
    }

  }

}
